var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 66.8351,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32979
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.75,
    cy: 67.5,
    r: 61.8351,
    fill: "#F2F9F1",
    stroke: "#82C275",
    strokeWidth: 1.32979
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5869 44.5115V98.3047H89.6562V44.5115H78.1979H59.6938H47.5869Z",
    fill: "white",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2266 59.3035H62.991",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9648 58.7132L55.3244 61.6626L59.4535 56.9436",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2266 71.1008H62.991",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9648 70.5108L55.3244 73.4602L59.4535 68.7412",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2266 82.8992H62.991",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9648 82.3085L55.3244 85.2578L59.4535 80.5388",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1992 47.3088V40.6095H64.987C64.987 38.9346 65.5809 35.585 69.6111 35.585C72.9626 35.585 74.2353 38.9346 74.2353 40.6095H80.3442V47.3088H58.1992Z",
    fill: "#82C275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanSet);
export default __webpack_public_path__ + "static/media/PlanSet.500857577cb2a2b42dd5412e45b893dc.svg";
export { ForwardRef as ReactComponent };